import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRemoveCircleOutline = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 12.75C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25V12.75ZM8 11.25C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75V11.25ZM16 11.25H8V12.75H16V11.25ZM12 20.25C7.44321 20.25 3.75 16.5568 3.75 12H2.25C2.25 17.3852 6.61479 21.75 12 21.75V20.25ZM3.75 12C3.75 7.44321 7.44321 3.75 12 3.75V2.25C6.61479 2.25 2.25 6.61479 2.25 12H3.75ZM12 3.75C16.5568 3.75 20.25 7.44321 20.25 12H21.75C21.75 6.61479 17.3852 2.25 12 2.25V3.75ZM20.25 12C20.25 16.5568 16.5568 20.25 12 20.25V21.75C17.3852 21.75 21.75 17.3852 21.75 12H20.25Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgRemoveCircleOutline);
export default ForwardRef;
